<template>
  <div class="film_calculator">
    <!--[START] Film Format -->
    <div class="film_calculator__label_input">
      <ValidatedFormInput
        ref="calcFormatInput"
        label-text="Film Format"
        input-type="select"
        starting-value="16"
        input-id="calcFormat"
        input-name="calcFormat"
        @onValueChange="inputValueUpdated"
        :input-options="[
          { label: '8mm', value: '80' },
          { label: 'Super 8mm', value: '72' },
          { label: '16mm', value: '40' },
          { label: '35mm 2-perf', value: '32' },
          { label: '35mm 3-perf', value: '21.333' },
          { label: '35mm', value: '16' },
          { label: '65mm', value: '12.8' },
        ]"
      />
    </div>
    <!--[END] Film Format -->
    <!--[START] Speed -->
    <div class="film_calculator__label_input">
      <FormLabel input-id="speed" :label-text="'Speed (FPS)'" for="speed" />
      <ValidatedFormInput
        required
        ref="filmSpeedInput"
        format-type="custom"
        starting-value="24"
        :format-options="{
          numeral: true,
        }"
        input-id="calcSpeed"
        input-name="calcSpeed"
        @onValueChange="inputValueUpdated"
      />
    </div>
    <!--[END] Speed -->
    <!--[START] Feet  -->
    <div class="film_calculator__label_input">
      <FormLabel input-id="feet" :label-text="'Feet'" for="feetInput" />
      <ValidatedFormInput
        required
        ref="feetInput"
        format-type="custom"
        starting-value="400"
        :format-options="{
          numeral: true,
        }"
        input-id="feetInput"
        input-name="feetInput"
        @onValueChange="inputValueUpdated"
      />
    </div>
    <!--[END] Feet -->
    <!--[START] Frames  -->
    <div class="film_calculator__label_input">
      <FormLabel input-id="frames" :label-text="'Frames'" for="framesInput" />
      <ValidatedFormInput
        required
        ref="framesInput"
        format-type="custom"
        :format-options="{
          numeral: true,
        }"
        input-id="framesInput"
        input-name="framesInput"
        @onValueChange="inputValueUpdated"
      />
    </div>
    <!--[END] Frames -->
    <!--[START] Time  -->
    <div class="film_calculator__label_input">
      <FormLabel input-id="time" :label-text="'Time'" for="min" />
      <div class="film_calculator__time_input">
        <div class="film_calculator__time_cell">
          <ValidatedFormInput
            required
            ref="minsInput"
            format-type="custom"
            starting-value="0"
            :format-options="{
              numeral: true,
            }"
            input-id="minsInput"
            input-name="minsInput"
            @onValueChange="inputValueUpdated"
            style="display: inline-block"
          />
          <div class="film_calculator__time_cell_label_container">
            <label><em>Minutes</em></label>
          </div>
        </div>
        <div class="film_calculator__time_cell">
          <ValidatedFormInput
            required
            ref="secsInput"
            format-type="custom"
            starting-value="0"
            :format-options="{
              numeral: true,
            }"
            input-id="secsInput"
            input-name="secsInput"
            @onValueChange="inputValueUpdated"
            style="display: inline-block"
          />
          <div class="film_calculator__time_cell_label_container">
            <label><em>Seconds</em></label>
          </div>
        </div>
      </div>
    </div>
    <!--[END] Time -->
  </div>
</template>
<script>
import { log } from 'JS/global';
import FormLabel from 'Components/form/FormLabel.vue';
import ValidatedFormInput from 'Components/form/ValidatedFormInput.vue';

export default {
  name: 'FilmCalculator',
  components: {
    FormLabel,
    ValidatedFormInput,
  },
  data() {
    return {
      calculatorLocked: true,
    };
  },
  methods: {
    inputValueUpdated(name, value) {
      // Called when an input value is updated.

      if (!this.calculatorLocked) {
        // Only Perform after First Calculation

        switch (name) {
          case 'calcFormat':
            // Format Value Changed
            // console.log('Format Value Changed: '+this.$refs.calcFormatInput.inputValue);
            this.performFilmCalculation();
            break;

          case 'calcSpeed':
            // Speed Value Changed
            // console.log('Speed Value Changed: '+this.$refs.filmSpeedInput.inputValue);
            this.performFilmCalculation();
            break;

          case 'feetInput':
            // Feet Value Changed
            // console.log('Feet Value Changed: '+this.$refs.feetInput.inputValue);
            this.performFilmCalculation();
            break;

          case 'framesInput':
            // Frames Value Changed
            // console.log('Frames Value Changed: '+this.$refs.framesInput.inputValue);
            this.performFilmCalculation();
            break;

          case 'minsInput':
            // Minutes Value Changed
            // console.log('Minutes Value Changed: '+this.$refs.minsInput.inputValue);
            this.performTimeCalculation();
            break;

          case 'secsInput':
            // Seconds Value Changed
            // console.log('Seconds Value Changed: '+this.$refs.secsInput.inputValue);
            this.performTimeCalculation();
            break;

          default:
            log('Error No Input Found');
        }
      }
    },
    performFilmCalculation() {
      // Performs Film Calculation

      const vue = this;
      this.calculatorLocked = true;

      // Frames = (Film Format Value x Feet x 1000) ÷ 1000
      this.$refs.framesInput.inputValue =
        Math.round(this.$refs.calcFormatInput.inputValue * this.$refs.feetInput.inputValue * 1000) / 1000;
      // Total Seconds = Frames ÷ Film Speed
      const totalSeconds = this.$refs.framesInput.inputValue / this.$refs.filmSpeedInput.inputValue;
      // Minutes = Total Seconds ÷ 60
      this.$refs.minsInput.inputValue = Math.floor(totalSeconds / 60);
      // Seconds = (Total Seconds - (Minutes x 60)) ÷ 1000
      this.$refs.secsInput.inputValue = Math.round((totalSeconds - this.$refs.minsInput.inputValue * 60) * 1000) / 1000;

      setTimeout(function () {
        // Wait 300 miliseconds
        vue.calculatorLocked = false;
      }, 300);
    },
    performTimeCalculation() {
      // Performs Time Calculation

      log('Perform Time Calculation');

      const vue = this;
      this.calculatorLocked = true;

      // Total Seconds = Minutes x 60 + Seconds
      const totalSeconds =
        parseFloat(this.$refs.minsInput.inputValue) * 60 + parseFloat(this.$refs.secsInput.inputValue);
      // Frames = (Total Seconds x Speed x 1000) ÷ 1000
      this.$refs.framesInput.inputValue =
        Math.round(totalSeconds * parseFloat(this.$refs.filmSpeedInput.inputValue) * 1000) / 1000;
      // Feet = ((Frames ÷ Film Format Value) x 1000) ÷ 1000
      this.$refs.feetInput.inputValue =
        Math.round((this.$refs.framesInput.inputValue / parseFloat(this.$refs.calcFormatInput.inputValue)) * 1000) /
        1000;

      setTimeout(function () {
        // Wait 300 miliseconds.
        vue.calculatorLocked = false;
      }, 300);
    },
    performFirstCalculation() {
      // Performs the First Calculation

      const vue = this;
      setTimeout(function () {
        // Wait 300 miliseconds to give Vue some time to populate fields with values.
        vue.calculatorLocked = false;
        vue.performFilmCalculation();
      }, 1000);
    },
  },
  mounted() {
    // Initiate Calculator
    this.performFirstCalculation();
  },
};
</script>
<style lang="scss">
.film_calculator {
  $self: &;
  background-color: #fff;
  padding-top: 50px;
  padding-bottom: 50px;
  @at-root #{$self}__time_input {
    display: flex;
  }
  @at-root #{$self}__time_cell {
    display: inline-flex;
    width: 50%;
  }
  @at-root #{$self}__time_cell_label_container {
    padding: 13px;
  }
}
</style>
